import React, { useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './ReviewConfirmation.module.scss'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import * as Data from 'shared/const/data.js'
import moment from 'moment-timezone'

const DriverInfo = ({ t, i18n, setIsError }) => {
  let history = useHistory()
  const timezone = process.env.REACT_APP_TIME_ZONE.toString()
  moment.tz.setDefault(timezone)

  const typeRoadTest = useSelector((state) => state.driver.driverInformation.typeRoadTest)
  const masterNumber = useSelector((state) => state.driver.driverInformation.masterNumber)
  const driverFirstName = useSelector((state) => state.driver.driverInformation.driverFirstName)
  const driverLastName = useSelector((state) => state.driver.driverInformation.driverLastName)
  const dateOfBirth = useSelector((state) => state.driver.driverInformation.dateOfBirth)
  const emailAddress = useSelector((state) => state.driver.driverInformation.emailAddress)
  const phoneNumber = useSelector((state) => state.driver.driverInformation.phoneNumber)

  useEffect(() => {
    try {
      if (
        typeRoadTest === 'select' ||
        masterNumber === '' ||
        driverFirstName === '' ||
        driverLastName === '' ||
        dateOfBirth === '' ||
        emailAddress === '' ||
        phoneNumber === ''
      ) {
        history.push(`/${i18n.language}${t('routes.school_question')}`)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [])

  const checkNull = (val) => {
    return val === '' ? 'null' : val
  }

  const editDrivingSchoolOnClick = () => {
    history.push(`/${i18n.language}${t('routes.driver_info')}`)
  }

  const getDateOfBirthFormat = (date) => {
    return moment(date).format('MMMM DD, YYYY')
  }

  const getAmountString = (num) => {
    try {
      return i18n.language === 'en' ? `$ ${num}` : `${num.toString().replace('.', ',')} $`
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <React.Fragment>
      <div>
        <div className="row">
          <div className="col-xs-12 col-md-5 col-sm-7 col-lg-5">
            <strong className={styles['margin_bottom']}>{t('review_confirmation.driver_name')}</strong>
          </div>
          {/* <div className={styles['display_none_desktop']}>
            <div className="col-xs-3">
              <button
                className="btn-sm btn-default"
                style={{ margin: '0' }}
                onClick={editDrivingSchoolOnClick}
                value={`driver info ${t('review_confirmation.edit')}`}
                name={`driver info ${t('review_confirmation.edit')}`}
              >
                {t('review_confirmation.edit')}
              </button>
            </div>
          </div> */}
          <div className="col-xs-12 col-md-5 col-sm-5 col-lg-7">
            <p className={[styles['margin_bottom'], styles['break_word']].join(' ')}>
              {checkNull(driverFirstName)} {driverLastName}
            </p>
          </div>
          {/* <div className={styles['display_visible_desktop']}>
            <div className="col-md-2 col-sm-2 col-lg-2">
              <button
                className="btn-sm btn-default"
                style={{ margin: '0' }}
                onClick={editDrivingSchoolOnClick}
                value={`driver info ${t('review_confirmation.edit')}`}
                name={`driver info ${t('review_confirmation.edit')}`}
              >
                {t('review_confirmation.edit')}
              </button>
            </div>
          </div> */}
        </div>
        <div className={['row', styles['display_flex']].join(' ')}>
          {/* <div className="col-xs-12 col-md-5 col-sm-5 col-lg-3"> */}
          <div className="col-xs-12 col-md-5 col-sm-7 col-lg-5">
            <strong className={[styles['margin_bottom'], styles['break_word']].join(' ')}>{t('review_confirmation.master_number')}</strong>
          </div>
          <div className="col-xs-12 col-md-7 col-sm-7 col-lg-7">
            <p className={styles['margin_bottom']} style={{ whiteSpace: 'pre-wrap' }}>
              {checkNull(masterNumber)}
            </p>
          </div>
        </div>
        {/* <div className={['row', styles['display_flex']].join(' ')}>
          <div className="col-xs-12 col-md-5 col-sm-5 col-lg-3">
            <strong className={styles['margin_bottom']}>{t('review_confirmation.type_road_test')}</strong>
          </div>
          <div className="col-xs-12 col-md-7 col-sm-7 col-lg-7">
            <p className={styles['margin_bottom']}>{checkNull(Data['roadTestTypes'][typeRoadTest][i18n.language])}</p>
          </div>
        </div> */}
        <div className="row">
          {/* <div className="col-xs-12 col-md-5 col-sm-5 col-lg-3">
            <strong className={styles['margin_bottom']}>{t('review_confirmation.cost')}</strong>
          </div>
          <div className="col-xs-12 col-md-7 col-sm-7 col-lg-7">
            <p className={styles['margin_bottom']}>{getAmountString((53.00).toFixed(2))}</p>
          </div> */}
          <div className="col-xs-12 col-md-5 col-sm-7 col-lg-5">
            <strong className={styles['margin_bottom']}>{t('review_confirmation.date_of_birth')}</strong>
          </div>
          <div className="col-xs-12 col-md-7 col-sm-7 col-lg-7">
            <p className={styles['margin_bottom']}>{getDateOfBirthFormat(checkNull(dateOfBirth))}</p>
          </div>
          <div className="col-xs-12 col-md-5 col-sm-7 col-lg-5">
            <strong className={styles['margin_bottom']}>{t('review_confirmation.driver_phone')}</strong>
          </div>
          <div className="col-xs-12 col-md-7 col-sm-7 col-lg-7">
            <p className={styles['margin_bottom']}>{checkNull(phoneNumber)}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-5 col-sm-7 col-lg-5">
            <strong className={styles['margin_bottom']}>{t('review_confirmation.email')}</strong>
          </div>
          <div className="col-xs-12 col-md-7 col-sm-7 col-lg-7">
            <p className={[styles['margin_bottom'], styles['break_word']].join(' ')}>{checkNull(emailAddress)}</p>
          </div>
        </div>
        {/* <div className="row">
          <div className="col-xs-12 col-md-5 col-sm-5 col-lg-3"></div>
          <div className="col-xs-12 col-md-7 col-sm-7 col-lg-7">
            <div className="help-text">
              <div style={{ display: 'flex' }}>
                <i className={['fa fa-exclamation-triangle', styles['warning_margin_right']].join(' ')} aria-hidden="true"></i>
                <p style={{ margin: 0, color: '#8a6d3b' }}>
                  <strong>{t('driver_information.email_warning_helper')}</strong>
                </p>
              </div>
            </div>
            <p className={styles['margin_bottom']}>
              <strong>
                {t('review_confirmation.your_receipt_will_be')}
                <br /> {t('review_confirmation.you_will_need')}
              </strong>
            </p>
          </div>
        </div> */}
      </div>
    </React.Fragment>
  )
}

export default withTranslation('common')(DriverInfo)
